import React, { useState, useEffect } from 'react';
import { DatePicker, Modal } from 'antd';
import dayjs from 'dayjs';
import './Thousand.css';

const Thousand = ({ defdata, onChange }) => {
  const parseInitialDates = () => {
    if (defdata && defdata.includes(',')) {
      const [startStr, endStr] = defdata.split(',').map(d => d.trim().split(' ')[0]);
      const start = dayjs(startStr);
      const end = dayjs(endStr);
      if (start.isValid() && end.isValid()) return [start, end];
    }
    return [null, null];
  };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const [start, end] = parseInitialDates();
    setStartDate(start);
    setEndDate(end);
  }, [defdata]);

  const formatFullDate = (date) =>
    date ? date.format('YYYY-MM-DD') + ' 00:00:00.000' : '';

  const triggerChange = (newStart, newEnd) => {
    if (newStart && newEnd) {
      const formattedStr = `${formatFullDate(newStart)},${formatFullDate(newEnd)}`;
      onChange?.(formattedStr);
    }
  };

  const handleStartChange = (date) => {
    if (endDate && date && date.isAfter(endDate)) {
      Modal.warning({
        title: 'Invalid Date Range',
        content: 'Start Date must be less than or equal to End Date.',
        centered:true
      });
      return;
    }

    setStartDate(date);
    triggerChange(date, endDate);
  };

  const handleEndChange = (date) => {
    if (startDate && date && date.isBefore(startDate)) {
      Modal.warning({
        title: 'Invalid Date Range',
        content: 'End Date must be greater than or equal to Start Date.',
        centered:true
      });
      return;
    }

    setEndDate(date);
    triggerChange(startDate, date);
  };

  return (
    <div style={{ padding: '15px 10px', display: 'flex', justifyContent:"space-between", alignItems: 'center' }}>
      <div className='form-group'>
        <label style={{ fontWeight: '600', fontSize: '18px' }}>Start Date</label>
        <DatePicker
         className="centered-datepicker"
          value={startDate}
            popupClassName="custom-centered-popup"
          format="YYYY-MM-DD"
          onChange={handleStartChange}
          style={{ width: 200 }}
          allowClear={false}
          getPopupContainer={trigger => trigger.parentNode}
        />
      </div>

      <div className='form-group'>
        <label style={{ fontWeight: '600', fontSize: '18px' }}>End Date</label>
        <DatePicker
          className="centered-datepicker"
          value={endDate}
            popupClassName="custom-centered-popup"
          format="YYYY-MM-DD"
          onChange={handleEndChange}
          style={{ width: 200 }}
          allowClear={false}
          getPopupContainer={trigger => trigger.parentNode}
        />
      </div>
    </div>
  );
};

export default Thousand;
